import { LogLevel } from '@azure/msal-browser';
import appSettings from '../appSettings';
import { logError } from '../common/utilities/AppInsightsUtil';
import { SeverityLevel } from '@microsoft/applicationinsights-web';

const ua = window.navigator.userAgent;
const msie = ua.indexOf('MSIE ');
const msie11 = ua.indexOf('Trident/');
const msedge = ua.indexOf('Edge/');
const firefox = ua.indexOf('Firefox');
const isIE = msie > 0 || msie11 > 0;
const isEdge = msedge > 0;
const isFirefox = firefox > 0;

// get the string name of the authority rather than the entire url.
const getSegment = (url) => {
  const parts = url.trim('/').split('/');
  return parts[parts.length - 2];
};

export const b2cPolicies = {
  names: {
      signIn: getSegment(appSettings.AZURE_AD_AUTHORITY),
      forgotUserId: getSegment(appSettings.AZURE_FORGOT_USER_ID),
      forgotPassword: getSegment(appSettings.AZURE_CHANGE_PASSWORD),
      editUserId: getSegment(appSettings.AZURE_CHANGE_USER_ID),
      editMFA: getSegment(appSettings.AZURE_CHANGE_MFA),
      changePassword: getSegment(appSettings.AZURE_CHANGE_PASSWORD)
  },
  authorities: {
      signIn: {
          authority: appSettings.AZURE_AD_AUTHORITY
      },
      forgotUserId: {
        authority: appSettings.AZURE_FORGOT_USER_ID
      },
      forgotPassword: {
        authority: appSettings.AZURE_CHANGE_PASSWORD
      },
      editUserId: {
        authority: appSettings.AZURE_CHANGE_USER_ID
      },
      editMFA: {
        authority: appSettings.AZURE_CHANGE_MFA
      },
      changePassword: {
        authority: appSettings.AZURE_CHANGE_PASSWORD
      }
  },
  authorityDomain: "login.amig.com",
  devAuthorityDomain: "dev-login.amig.com"
}

export const msalConfig =  {
  auth: {
    authority: appSettings.AZURE_AD_AUTHORITY,
    knownAuthorities: [b2cPolicies.authorityDomain, b2cPolicies.devAuthorityDomain],
    clientId: appSettings.AZURE_AD_CLIENT_ID,
    redirectUri: appSettings.AZURE_AD_CLIENT_REDIRECT_URI,
    postLogoutRedirectUri: appSettings.AZURE_AD_CLIENT_REDIRECT_URI
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: isIE || isEdge || isFirefox,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            logError(message, SeverityLevel.Error, 'authConfig'); // added appinsights to capture error
            console.error(message);
            return;
          case LogLevel.Info:
            console.info(message);
            return;
          case LogLevel.Verbose:
            console.debug(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
          default:
            return;
        }
      },
    },
  },
};

// Add here scopes for id token to be used at MS Identity Platform endpoints.
export const loginRequest = {
  scopes: [
    'openid',
  ],
  // `userData` is a custom parameter forwarded to the CIAM policy.
  // `login_hint` is OIDC-standard — set it at call time when we know the email.
  extraQueryParameters: { userData: '' }
};

// Add here the endpoints for MS Graph API services you would like to use.
export const graphConfig = {
  graphMeEndpoint: 'https://graph.microsoft.com/v1.0/me',
};
